// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"ccad404b1c917008","5808":"53e2a3b31477ca62"}[chunkId] + ".css";
};